var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHaha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ha",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13565",
    "data-name": "Group 13565",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7682",
    "data-name": "Ellipse 7682",
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#ecb13a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13566",
    "data-name": "Group 13566",
    transform: "translate(-0.725 0.054)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7683",
    "data-name": "Ellipse 7683",
    cx: 9.445,
    cy: 9.445,
    r: 9.445,
    fill: "#ffde4f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13567",
    "data-name": "Group 13567",
    transform: "translate(3.236 9.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15383",
    "data-name": "Path 15383",
    d: "M107.084,245.4a.75.75,0,0,1,.757.814c-.307,3.36-2.7,5.984-5.623,6.016s-5.37-2.542-5.748-5.894a.748.748,0,0,1,.739-.828Z",
    transform: "translate(-96.465 -245.399)",
    fill: "#645033"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13568",
    "data-name": "Group 13568",
    transform: "translate(3.399 5.076)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7684",
    "data-name": "Ellipse 7684",
    cx: 1.232,
    cy: 1.232,
    r: 1.232,
    transform: "translate(0)",
    fill: "#645033"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13569",
    "data-name": "Group 13569",
    transform: "translate(12.099 5.092)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7685",
    "data-name": "Ellipse 7685",
    cx: 1.232,
    cy: 1.232,
    r: 1.232,
    fill: "#645033"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13570",
    "data-name": "Group 13570",
    transform: "translate(3.87 10.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15384",
    "data-name": "Path 15384",
    d: "M119.252,267.457l-5.052.054a5.2,5.2,0,0,0,.482,1.735l.054.111,4.538-.05,4.538-.05.05-.111a5.24,5.24,0,0,0,.443-1.746Z",
    transform: "translate(-114.2 -267.4)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13571",
    "data-name": "Group 13571",
    transform: "translate(6.147 13.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15385",
    "data-name": "Path 15385",
    d: "M182.966,354.99a4.176,4.176,0,0,0-4.877.054l-.389.278.4.268a4.176,4.176,0,0,0,4.877-.054l.389-.278Z",
    transform: "translate(-177.7 -354.23)",
    fill: "#ef4f43"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaha);
export default __webpack_public_path__ + "static/media/haha.beb380105045aa9ce4e03783754d68ff.svg";
export { ForwardRef as ReactComponent };